module.exports = __webpack_public_path__ + "img/pixel-logo-2.238995da.svg";